import React from 'react';

/** Badge événement vedette — dégradé or, reflet et léger shimmer */
export default function FeaturedEventBadge({ className = '' }) {
    return (
        <span
            className={`relative isolate inline-flex items-center gap-1 overflow-hidden rounded-full border border-amber-200/90 bg-gradient-to-r from-amber-900 via-amber-600 to-yellow-400 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white shadow-[0_2px_12px_rgba(180,83,9,0.42),inset_0_1px_0_rgba(255,255,255,0.38)] ring-1 ring-white/30 ${className}`}
            aria-label="Événement vedette"
        >
            <svg
                className="relative z-[1] h-3 w-3 shrink-0 text-amber-50 drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden
            >
                <path d="M12 1.5l2.09 6.44h6.77l-5.48 3.98 2.09 6.43L12 14.36 6.53 18.35l2.09-6.43L3.14 7.94h6.77L12 1.5z" />
            </svg>
            <span className="relative z-[1]">Vedette</span>
            <span className="pointer-events-none absolute inset-0 overflow-hidden rounded-full" aria-hidden>
                <span className="absolute -left-full top-0 h-full w-[55%] bg-gradient-to-r from-transparent via-white/45 to-transparent motion-safe:animate-featured-badge-shimmer" />
            </span>
        </span>
    );
}
